export default __webpack_public_path__ + "0978d652c4217026312cfb45e4c8e191.webp";